<kilowant-header title="Forgot Password" [isHome]="true" [linkHome]="previousUrl"></kilowant-header>
<div class="wrapper-main-public-area">
  @if (!changePasswordMode && !forgotPasswordLinkSent) {
    <div class="form"  style="margin-top: calc(50vh - 170px)">
      <input type="text" id="login" name="login" value="" (input)="resetError()" [(ngModel)]="login" class="w-100"
        placeholder="Email address" />
      <div class="jtw" [style.display]="(showError)? 'block' : 'none'">
        {{error}}
      </div>
      <div class="jtw" [style.display]="(showSendActivation)? 'block' : 'none'">
        Your account already exists, but not activated.<br /><br />Please,
        <a href="/user/activation?email={{login}}">click here</a> to send an activation
        link again.
      </div>
      <div class="d-flex">
        <button type="button" class="auto loginBtnsBorder f14"
          [style.display]="(!showError && !showSendActivation)? 'block' : 'none'"
        (click)="sendForgotPasswordLink()">Remind Password</button>
      </div>
    </div>
  }
  @if (forgotPasswordLinkSent ) {
    <div class="form text-block"  style="margin-top: calc(50vh - 170px)">
      We've emailed you a link<br />to reset your password at this address<br /><b
    class="yellow ">{{login}}</b><br /><br /> If you haven't received our email,<br />please check your spam folder.
  </div>
}

@if (!operationCompleted && showForm ) {
  <div class="form thick" style="margin-top: calc(50vh - 170px)">
    <input type="password" name="Password" class="required" value=" " (input)="resetError()" [type]="passwordType"
      [(ngModel)]="password" placeholder="New password" />
    <div class="password-holder" (click)="showPassword(1)">
      <i [class]="(passwordType=='password')?'password-show':'password-hide'"></i>
    </div>
    <input type="password" name="Password2" class="required" value=" " (input)="resetError()" [type]="passwordType2"
      [(ngModel)]="password2" placeholder="New password (confirm)" />
    <div class="password-holder" (click)="showPassword(2)">
      <i [class]="(passwordType2=='password')?'password-show':'password-hide'"></i>
    </div>
    <div class="d-flex">
      <input type="button " value="UPDATE PASSWORD" [style.display]="(!showError)? 'block' : 'none' "
        (click)="sendForm()" class="auto loginBtnsBorder f14" />
    </div>
    <div class="jtw" [style.display]="(showError)? 'block' : 'none' ">
      <div class="d-flex">
        <input type="button " value="UPDATE PASSWORD" (click)="sendForm()" class="auto loginBtnsBorder f14" />
      </div>
      {{error}}
    </div>
  </div>
}

@if (operationCompleted ) {
  <div class="form text-block"  style="margin-top: calc(50vh - 170px)">
    The password has been updated.
  </div>
}
</div>